import React from 'react'
import UploadFile from '../../containers/UploadFile'
import { Button } from '@material-ui/core'
import ZestawienieNameStyle from '../../styles/ZestawienieNameStyle'

const ZestawienieName = ({ name, onImport, onClear, hideButtons }) => (
  <ZestawienieNameStyle>
    <div className="header-text">{name}</div>
    {!hideButtons && (
      <>
        <UploadFile
          label="IMPORTUJ"
          onUpload={onImport}
          variant="outlined"
          filter=".csv"
        />
        <Button onClick={onClear} variant="outlined" color="primary">
          WYCZYŚĆ
        </Button>
      </>
    )}
  </ZestawienieNameStyle>
)

export default ZestawienieName
